import { motion } from "framer-motion";

export default function AdminPage({
  title,
  subtitle,
  children,
  actions,
}) {
  return (
    <div className="p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex flex-col md:flex-row justify-between md:items-center gap-4 mb-8"
        >
          <div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
              {title}
            </h1>

            {subtitle && (
              <p className="text-gray-400 mt-2">
                {subtitle}
              </p>
            )}
          </div>

          {actions}
        </motion.div>

        {children}

      </div>
    </div>
  );
}